<template>
    <svg
        :width="size"
        :height="size"
        viewBox="0 0 13 13"
        :fill="color"
        xmlns="http://www.w3.org/2000/svg"
        :style="{ color }"
    >
        <mask id="edit" maskUnits="userSpaceOnUse" x="0" y="0" width="13" height="13">
            <path
                d="M10.982 5.181l1.39-1.39a1.078 1.078 0 000-1.514L10.405.318C10.204.118 9.927 0 9.643 0c-.285 0-.561.117-.753.318L7.5 1.7l3.482 3.482zm-7.5 7.5l6.964-6.964-3.482-3.482L0 9.199v3.482h3.482zM3.04 11.61h-.896v-1.071H1.07v-.896l.762-.762L3.8 10.848l-.761.762z"
                fill="#fff"
            />
        </mask>
        <g mask="url(#edit)">
            <path
                d="M10.982 5.181l1.39-1.39a1.078 1.078 0 000-1.514L10.405.318C10.204.118 9.927 0 9.643 0c-.285 0-.561.117-.753.318L7.5 1.7l3.482 3.482zm-7.5 7.5l6.964-6.964-3.482-3.482L0 9.199v3.482h3.482zM3.04 11.61h-.896v-1.071H1.07v-.896l.762-.762L3.8 10.848l-.761.762z"
            />
            <path d="M22-9h-32v32h32V-9z" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'EditSVG',
    props: {
        size: {
            type: Number,
            required: true,
        },
        color: {
            type: String,
            required: true,
        },
    },
};
</script>

<style></style>
